import React, { useState } from 'react';
import { Input, Button, Typography, message } from 'antd';
import './AddCategoryProvider.css';

const { Title } = Typography;

const AddCategoryProvider = () => {
  const [categoryName, setCategoryName] = useState('');

  const handleSave = async () => {
    if (!categoryName.trim()) {
      message.error('Veuillez entrer un nom de catégorie');
      return;
    }

    try {
      const response = await fetch('/backend/add_category.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ name: categoryName.trim() }),
      });
      const data = await response.json();
      if (response.ok) {
        message.success(data.message || 'Catégorie ajoutée avec succès');
        setCategoryName(''); // Clear input
      } else {
        message.error(data.error || `Erreur HTTP ${response.status}`);
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
      message.error('Erreur réseau lors de l\'ajout de la catégorie');
    }
  };

  return (
    <div className="add-category-provider-container">
      <Title level={3} className="add-category-provider-title">Add Category</Title>
      <div className="add-category-provider-form">
        <Input
          placeholder="Category Name"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          className="add-category-provider-input"
          size="large"
        />
        <Button
          type="primary"
          onClick={handleSave}
          className="add-category-provider-button"
          size="large"
          disabled={!categoryName.trim()}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default AddCategoryProvider;